var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 12.8578V3.85722C9.99986 1.728 8.31919 0 6.25012 0C4.18024 0 2.50039 1.728 2.50039 3.85722L2.50039 11.5717C2.50039 12.9912 3.62003 14.1429 4.99993 14.1429C6.37983 14.1429 7.49946 12.9911 7.49946 11.5717L7.49946 4.49972C7.49946 4.14485 7.21977 3.85715 6.87479 3.85715C6.52982 3.85715 6.25012 4.14486 6.25012 4.49972L6.25012 11.5717C6.25012 12.2814 5.68988 12.8577 4.99993 12.8577C4.30998 12.8577 3.74973 12.2814 3.74973 11.5717L3.74973 3.85722C3.74973 2.43773 4.87019 1.28603 6.25012 1.28603C7.6292 1.28603 8.74966 2.43776 8.74966 3.85722V12.8578C8.74966 14.9862 7.06982 16.715 4.99993 16.715C2.93004 16.715 1.2502 14.9862 1.2502 12.8578L1.2502 4.49972C1.2502 4.14485 0.970502 3.85715 0.625526 3.85715C0.280544 3.85715 0 4.14486 0 4.49972L0 12.8578C0 15.6959 2.24091 18 5 18C7.75909 18 10 15.6957 10 12.8578H9.99986Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach-icon.4049def23e0414c5c7b6801dee366663.svg";
export { ForwardRef as ReactComponent };